import React, { useState, useEffect } from 'react';
import { FaBriefcase, FaEye, FaHome, FaSmile, FaUsers, FaCity } from 'react-icons/fa';
import { getStats } from '../services/api';

const iconMap = {
  experience: <FaBriefcase className="text-2xl text-white" />,
  visits: <FaEye className="text-2xl text-white" />,
  sold: <FaHome className="text-2xl text-white" />,
  customers: <FaSmile className="text-2xl text-white" />,
  team: <FaUsers className="text-2xl text-white" />,
  cities: <FaCity className="text-2xl text-white" />,
};

const StatsSection = () => {
  const [stats, setStats] = useState([]);

  useEffect(() => {
    getStats().then(data => setStats(data || []));
  }, []);

  return (
    <section className="py-20 bg-gradient-to-br from-[#0f0c29] via-[#1a1a2e] to-[#302b63] relative overflow-hidden">
      <div className="absolute top-0 left-0 w-80 h-80 bg-red-500/10 rounded-full blur-3xl -translate-x-40 -translate-y-40"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-purple-500/10 rounded-full blur-3xl translate-x-40 translate-y-40"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-14">
          <span className="text-red-400 text-sm font-semibold uppercase tracking-wider">EXPERIENCE</span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mt-2">Proven Track Record</h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-6">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className="text-center group cursor-pointer"
            >
              <div className="w-16 h-16 bg-white/10 rounded-2xl mx-auto mb-4 flex items-center justify-center group-hover:bg-red-500/30 transition-colors">
                {iconMap[stat.icon]}
              </div>
              <h3 className="text-3xl font-bold text-white mb-1">{stat.number}</h3>
              <p className="text-sm text-gray-400">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
